import React, { Suspense, lazy, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home = lazy(() => import("../pages/msedcl/Home/index"));
const ExpiredPage = lazy(() => import("../pages/msedcl/ExpiredPage/ExpiredPage"));
const SessionWrapper = lazy(() => import("../pages/msedcl/ExpiredPage/SessionWrapper"));
const NotFound = lazy(() => import("../pages/msedcl/PageNotFound/NotFound"));
const RegisterComplain = lazy(() => import("../pages/msedcl/RegisterComplain/index"));
const TrackComplaintStatus = lazy(() => import("../pages/msedcl/TrackComplaintStatus/index"));
const ConsumerFeedback = lazy(() => import("../pages/msedcl/ConsumerFeedback/index"));
const EmailSubscription = lazy(() => import("../pages/msedcl/EmailSubscription/index"));
const EmailUnSubscription = lazy(() => import("../pages/msedcl/EmailUnSubscription/index.jsx"));
const TrackYourApplication = lazy(() => import("../pages/msedcl/TrackYourApplication/index"));
const Profile = lazy(() => import("../pages/msedcl/Profile/index"));
const NameChange = lazy(() => import("../pages/msedcl/NameChange/index"));
const AddressChange = lazy(() => import("../pages/msedcl/AddressChange/index"));
const Tariff = lazy(() => import("../pages/msedcl/Tariff/index"));
const GeneratePaySlip = lazy(() => import("../pages/msedcl/GeneratePaySlip/index"));
const UpdateProfile = lazy(() => import("../pages/msedcl/UpdateProfile/index"));
const LeaveApplication = lazy(() => import("../pages/msedcl/LeaveApplication/index"));
const ViewLeavesApplied = lazy(() => import("../pages/msedcl/ViewLeavesApplied/index"));
const ShowLeaves = lazy(() => import("../pages/msedcl/ShowLeaves/index"));
const CancelAppliedLeaves = lazy(() => import("../pages/msedcl/CancelAppliedLeaves/index"));
const HolidayList = lazy(() => import("../pages/msedcl/HolidayList/index"));
const MobileNumberUpdate = lazy(() => import("../pages/msedcl/MobileNumberUpdate/index"));
const MibileBills = lazy(() => import("../pages/msedcl/MibileBills/index"));
const OtBills = lazy(() => import("../pages/msedcl/OtBills/index"));
const BiometricAttendance = lazy(() => import("../pages/msedcl/BiometricAttendance/index"));
const FlagDay = lazy(() => import("../pages/msedcl/FlagDay/index"));
const FlagDayList = lazy(() => import("../pages/msedcl/FlagDay/flagday"));
const CpfAmount = lazy(() => import("../pages/msedcl/CpfAmount/index"));
const TaxRegime = lazy(() => import("../pages/msedcl/TaxRegime/index"));
const ViewTaxRegime = lazy(() => import("../pages/msedcl/ViewTaxRegime/index"));
const CPFApplicationList = lazy(() => import("../pages/msedcl/CPFApplicationList/index"));
const ViewClaims = lazy(() => import("../pages/msedcl/ViewClaims/index"));
const Taltc = lazy(() => import("../pages/msedcl/TALTC/Taltc"));
const Ltc = lazy(() => import("../pages/msedcl/Ltc/index"));
// const PaymentSummary = lazy(() => import("../pages/msedcl/PaymentSummary/PaymentSummary"));

const MsedclRoutes = () => {
  const { checksum } = useSelector((state) => state.culturalHeritageReducer);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (checksum?.acceptLanguage) {
      i18n.changeLanguage(checksum.acceptLanguage);
    }
  }, [checksum?.acceptLanguage, i18n]);

  return (
    <>
      <Suspense fallback={<div className="loading"></div>}>
        <Routes>
          {/* MSEDCL Route */}
          <Route path="/cb/wa/msedcl/ca-form/:checksum" element={<SessionWrapper />}>
            <Route index element={<Home />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/register-complain/:checksum" >
            <Route index element={<RegisterComplain />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/track-complaint-status/:checksum" >
            <Route index element={<TrackComplaintStatus />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/consumer-feedback/:checksum" >
            <Route index element={<ConsumerFeedback />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/gogreen-subscription/:checksum" >
            <Route index element={<EmailSubscription />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/email-unsubscription/:checksum" >
            <Route index element={<EmailUnSubscription />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/track-your-application/:checksum" >
            <Route index element={<TrackYourApplication />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/profile-change-request/:checksum" >
            <Route index element={<Profile />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/name-change/:checksum" >
            <Route index element={<NameChange />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/address-change/:checksum" >
            <Route index element={<AddressChange />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/tariff/:checksum" >
            <Route index element={<Tariff />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/generate-pay-slip/:checksum" >
            <Route index element={<GeneratePaySlip />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
           <Route path="/cb/wa/msedcl/view-update-profile/:checksum" >
            <Route index element={<UpdateProfile />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/leave-application/:checksum" >
            <Route index element={<LeaveApplication />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/view-applied-leaves/:checksum" >
            <Route index element={<ViewLeavesApplied />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/show-leaves/:checksum" >
            <Route index element={<ShowLeaves />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/cancel-applied-leaves/:checksum" >
            <Route index element={<CancelAppliedLeaves />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/holiday-list/:checksum" >
            <Route index element={<HolidayList />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/update-consumer-number/:checksum" >
            <Route index element={<MobileNumberUpdate />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/mobile-bills/:checksum" >
            <Route index element={<MibileBills />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/ot-bills/:checksum" >
            <Route index element={<OtBills />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/biometric-attendance/:checksum" >
            <Route index element={<BiometricAttendance />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/flag-day/:checksum" >
            <Route index element={<FlagDay />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/flag-day-list/:checksum" >
            <Route index element={<FlagDayList />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/cpf-amount/:checksum" >
            <Route index element={<CpfAmount />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/tax-regime/:checksum" >
            <Route index element={<TaxRegime />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/view-tax-regime/:checksum" >
            <Route index element={<ViewTaxRegime />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/cpf-application-list/:checksum" >
            <Route index element={<CPFApplicationList />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/view-claims/:claimType/:checksum" >
            <Route index element={<ViewClaims />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/taltc/:checksum" >
            <Route index element={<Taltc />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/msedcl/ltc/:checksum" >
            <Route index element={<Ltc />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>

      {/* Toast Notifications */}
      <ToastContainer />
    </>
  );
};

export default MsedclRoutes;
